import { useRouter } from 'next/dist/client/router'
import Image from 'next/image'
import { useContext } from 'react'
import ButtonRoundWithHarpoon from 'src/components/shared/ButtonRoundWithHarpoon'
import { LocaleContext } from 'src/contexts/contextapi'
import { textFactory } from 'src/locale/textFactory'
import styles from './MainTeamIntro.module.scss'

export default function MainTeamIntro() {
  const text = textFactory()
  const { locale } = useContext(LocaleContext)
  const router = useRouter()
  return (
    <div className={ styles.MainTeamIntro }>
      <div className={ styles.coverImage }>
        <Image
          src="/images/codeit-team.png"
          alt="Picture of codeit team"
          layout="fill"
          objectFit="cover"
          loader={ () => 'codeit-team.png' }
          unoptimized
        />
      </div>
      <div className={ styles.sloganBackground }>
        <p
          className={ styles.slogan }
          dangerouslySetInnerHTML={ { __html: text.MainTeamIntro_codeit_team_slogan } }
        />
        <ButtonRoundWithHarpoon
          message={ text.MainTeamIntro_introduce_teams }
          onClick={ () => router.push(`/${locale}/teams`) }
          className={ styles.routingTeamsButton }
        />
      </div>
    </div>
  )
}
